import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../app.config';

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(
    private http: HttpClient,
    private config: AppConfig
  ) {
  }

  uploadUrl(url): Observable<any> {
    const fd = new FormData();
    fd.append('file', url);

    return this.upload(fd);
  }

  upload(formData: FormData): Observable<any> {
    return this.http.put(this.config.getEndpoint('image/upload'), formData);
  }

  remove(id): Observable<any> {
    return this.http.delete(this.config.getEndpoint(`image/remove/?image_id=${id}`));
  }

  get(id): Observable<any> {
    const params: HttpParams = new HttpParams()
      .append('image_id', id)
      .append('dimension', '250');
    return this.http.get(this.config.getEndpoint('public/image'), {params});
  }
}
